@if (sourceId && sourceType) {
  <ngx-simplebar [options]="{ autoHide: false }" class="widget temperatureDisplay">
    <app-temperature-display
      [insideTemperature]="energyToolFacade.insideTemp()"
      [outsideTemperature]="energyToolFacade.outsideTemp()"
    ></app-temperature-display>
  </ngx-simplebar>

  <ngx-simplebar [options]="{ autoHide: false }" class="widget expectedEnergyLoss">
    <app-expected-energy-loss
      [energyLoss]="energyToolFacade.energyLoss()"
      [expectedEnergyLossPerDay]="energyToolFacade.expectedEnergyLossPerDay()"
      [energyCost]="energyToolFacade.energyCost()"
      (changeTimeframeEvent)="onChangeTimeExpecteEnergyLoss($event)"
    ></app-expected-energy-loss>
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget doughnutChart">
    <app-doughnut-chart
      [chartData]="energyToolFacade.doughnutChartEnergyLoss()"
      [sourceType]="sourceType"
      (changeTimeframeEvent)="onChangeTimeDoughnutChart($event)"
      chartId="buildingDoughnutChart"
    ></app-doughnut-chart>
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget weatherReport">
    <app-weather-report
      [sourceType]="sourceType"
      [forecastWeatherData]="energyToolFacade.forecastWeather()"
      [forecastEnergyLossData]="energyToolFacade.forecastEnergyLoss()"
    ></app-weather-report>
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget barChart">
    <app-bar-chart
      [chartData]="energyToolFacade.barChartEnergyLoss()"
      (changeTimeframeEvent)="onChangeTimeBarChart($event)"
      [sourceType]="sourceType"
      [sourceId]="sourceId"
      chartId="buildingBarChart"
    >
    </app-bar-chart>
  </ngx-simplebar>
  <ngx-simplebar [options]="{ autoHide: false }" class="widget lineChart">
    <app-line-chart
      [chartData]="energyToolFacade.lineChartEnergyLoss()"
      (changeTimeframeEvent)="onChangeTimeLineChart($event)"
      [sourceType]="sourceType"
      [sourceId]="sourceId"
      chartId="buildingLineChart"
    ></app-line-chart>
  </ngx-simplebar>
}
